// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"Or-z","summaryPar":"Pr-z","ratingCategories":"Qr-z","reviewerInfo":"Rr-z","reviewTypes":"Sr-z","expanded":"Tr-z"};